const transitions = {
  easeIn: 'all 100ms ease-in',
  easeOut: 'all 100ms ease-out',
  linear: 'all 100ms linear',
};

export default transitions;
